import api from 'Application/api/api';

const giveProjectQuestionTextAnswer = (
    projectId,
    questionId,
    isCustom,
    answer,
    cancelToken = null,
) =>
    api.post(
        `project-manager/projects/${projectId}/questionnaire/questions/${questionId}/${
            isCustom ? 1 : 0
        }/answers/text`,
        {
            answer,
        },
        { cancelToken },
    );

export default giveProjectQuestionTextAnswer;
